import type { ManualReason, QuoteInput, RoomInput } from './types';

const isFiniteNumber = (value: number): boolean => Number.isFinite(value);

export function validateRoom(room: RoomInput): string[] {
  const errors: string[] = [];
  const ranges: Array<[keyof Pick<RoomInput, 'length' | 'width' | 'height' | 'doors' | 'windows' | 'radiators' | 'paintedDoors' | 'paintedRadiators'>, number, number]> = [
    ['length', 1.5, 15],
    ['width', 1.5, 15],
    ['height', 2, 5],
    ['doors', 0, 10],
    ['windows', 0, 15],
    ['radiators', 0, 10],
    ['paintedDoors', 0, 10],
    ['paintedRadiators', 0, 10]
  ];

  const integerFields = new Set(['doors', 'windows', 'radiators', 'paintedDoors', 'paintedRadiators']);

  for (const [key, min, max] of ranges) {
    const value = room[key];
    if (!isFiniteNumber(value) || value < min || value > max || (integerFields.has(key) && !Number.isInteger(value))) {
      errors.push(String(key));
    }
  }

  if (!room.paintWalls && !room.paintCeiling && !room.paintSkirting && room.paintedDoors === 0 && room.paintedRadiators === 0) {
    errors.push('surfaces');
  }

  if (room.paintedDoors > room.doors) errors.push('paintedDoors');
  if (room.paintedRadiators > room.radiators) errors.push('paintedRadiators');

  return errors;
}

export function getManualReasons(input: QuoteInput): ManualReason[] {
  const reasons: ManualReason[] = [];

  if (input.rooms.length > 5) reasons.push({ code: 'tooManyRooms' });
  if (input.rooms.length === 0) reasons.push({ code: 'noRooms' });
  if (input.travel === 'outside') reasons.push({ code: 'outsideServiceArea' });

  for (const room of input.rooms) {
    if (room.condition === 'specialist') reasons.push({ code: 'specialistAssessment', roomId: room.id });
    if (room.height > 4) reasons.push({ code: 'heightOverFour', roomId: room.id });
    if (room.issues.moistureOrMould) reasons.push({ code: 'moistureOrMould', roomId: room.id });
    if (room.issues.unstableSurface) reasons.push({ code: 'unstableSurface', roomId: room.id });
    if (room.issues.scaffoldingRequired) reasons.push({ code: 'scaffoldingRequired', roomId: room.id });
    if (room.issues.specialistFinish) reasons.push({ code: 'specialistFinish', roomId: room.id });
    if (room.issues.fullReplastering) reasons.push({ code: 'fullReplastering', roomId: room.id });
    if (room.issues.exteriorWork) reasons.push({ code: 'exteriorWork', roomId: room.id });
  }

  return reasons;
}
